import React from 'react';
import PropTypes from 'prop-types';

import 'sass/ToggleButton.scss';

export default function ToggleButton(props) {
    let active = props.active ? props.active : false;
    let onToggleOn = props.onToggleOn ? props.onToggleOn : function() {};
    let onToggleOff = props.onToggleOff ? props.onToggleOff : function() {};
    let titleWhenOn = props.titleWhenOn ? props.titleWhenOn : "Slide to off";
    let titleWhenOff = props.titleWhenOff ? props.titleWhenOff : "Slide to on";
    let title = props.title ? props.title : "";

    let classes = ["toggle-button", "active"];
    if (active) {
        classes.push("turn-off")
    } else {
        classes.push("turn-on")
    };

    if (title == "") {
        return <a href="#" className={classes.join(" ")} title={ active ? titleWhenOn : titleWhenOff } onClick={ active ? onToggleOff : onToggleOn }><span></span></a>
    } else {
        return (
            <div className="toggle-button">
                <a href="#" className={classes.join(" ")} title={ active ? titleWhenOn : titleWhenOff } onClick={ active ? onToggleOff : onToggleOn }><span></span></a>
                <span className="title">{title}</span>
            </div>
        );
    }
}

ToggleButton.propTypes = {
    active: PropTypes.bool,
    onToggleOn: PropTypes.func,
    onToggleOff: PropTypes.func,
    titleWhenOn: PropTypes.string,
    titleWhenOff: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/ToggleButton.js